import React, { createContext, useContext, useEffect, useState } from "react";
import Constants from "../../rz-status_constants";

type TimerContextType = {
  value: number;
};

const TimerContext = createContext<TimerContextType | undefined>(undefined);

export function TimerProvider({ children }:{children: React.FC}) {
    const [tick, setTick] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
        setTick(t => t + 1);
        }, Constants.Refresh.intervallInSeconds * 1000);

        return () => clearInterval(interval);
    }, []);

    return <TimerContext value={tick}>
        {children}
    </TimerContext>
}


export const useTimer = () => {
    const context = useContext(TimerContext);
    // if (!context) throw new Error('useTimer must be used within a TimerContext');
    return context;
};